// To see this message, add the following to the `<head>` section in your
// views/layouts/application.html.erb
//
//    <%= vite_client_tag %>
//    <%= vite_javascript_tag 'application' %>
console.log('Vite ⚡️ Rails')

// If using a TypeScript entrypoint file:
//     <%= vite_typescript_tag 'application' %>
//
// If you want to use .jsx or .tsx, add the extension:
//     <%= vite_javascript_tag 'application.jsx' %>

console.log('Visit the guide for more information: ', 'https://vite-ruby.netlify.app/guide/rails')

// Example: Load Rails libraries in Vite.
//
import "@hotwired/turbo-rails"


// ["turbo:load",
//   "turbo:click",
//   "turbo:render",
//   "turbo:frame-load",
//   "turbo:frame-render",
//   "turbo:before-fetch-request",
//   "turbo:before-fetch-response",
//   "turbo:before-prefetch",
//   "turbo:submit-start",
//   "turbo:submit-end",
//   "turbo:morph-element",
//   "turbo:morph",
//   "turbo:before-morph-element",
//   "turbo:stream-render",
//   "turbo:before-stream-render"].forEach(event => {
//   document.addEventListener(event, () => console.log("fired:", event));
// });


import '../javascript/waitlist_form.js'
import '../javascript/banner_highlights.js'
// import ActiveStorage from '@rails/activestorage'
// ActiveStorage.start()
//
// // Import all channels.
// const channels = import.meta.glob('./**/*_channel.js', { eager: true })

// Example: Import a stylesheet in app/frontend/index.css
// import '~/index.css'
